<div class="ht-grids-outer">

<div class="ht-container">

  <!-- Company Holidays Header -->
  <div class="ht-header">
    <div class="ht-header-left">
      <span class="ht-title">{{ 'leave_management.holidays_tab.company_holidays' | transloco }}</span>
    </div>
  </div>

  <!-- Company Holidays Grid -->
  <div class="ht-grid-wrapper">
    <ers-grid
      [rowData]="holidays" [columnDefs]="colDefs"
      [gridOptions]="gridOptions">
    </ers-grid>
  </div>

</div>

<!-- Optional Holidays Section -->
<div class="ht-container">

  <!-- Optional Header -->
  <div class="ht-header">
    <div class="ht-header-left">
      <span class="ht-title">{{ 'leave_management.holidays_tab.optional_holidays' | transloco }}</span>
    </div>
    <div class="ht-header-right">
      <button class="lm-btn lm-btn--primary" (click)="onChooseOptionalHoliday()">
        <span class="material-icons ht-btn-icon">{{ hasSubmittedOptionalHolidays ? 'edit' : 'add_circle_outline' }}</span>
        {{ hasSubmittedOptionalHolidays ? 'Update' : 'Choose optional holiday' }}
      </button>
    </div>
  </div>

  <!-- Optional Grid -->
  <div class="ht-grid-wrapper">
    @if (isLoadingOptional || myOptionalHolidays.length > 0) {
      <ers-grid
        [rowData]="myOptionalHolidays"
        [columnDefs]="optionalColDefs"
        [gridOptions]="gridOptions">
      </ers-grid>
    } @else {
      <div class="ht-empty-state">
        <svg class="ht-empty-icon" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="20" y="15" width="55" height="70" rx="6" fill="#e2e8f0"/>
          <rect x="35" y="28" width="65" height="72" rx="6" fill="#f1f5f9" stroke="#cbd5e1" stroke-width="1.5"/>
          <rect x="47" y="44" width="30" height="4" rx="2" fill="#cbd5e1"/>
          <rect x="47" y="54" width="22" height="4" rx="2" fill="#e2e8f0"/>
          <rect x="47" y="64" width="26" height="4" rx="2" fill="#e2e8f0"/>
          <rect x="58" y="22" width="18" height="8" rx="4" fill="#94a3b8"/>
        </svg>
        <p class="ht-empty-text">{{ 'leave_management.holidays_tab.no_optional_holidays_found' | transloco }}</p>
      </div>
    }
  </div>

</div>

</div>